import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					title={"Harley Dykstra"}
					// image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A new and engaging online presence.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/harley-dykstra.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy together with a new website and email newsletter design.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Website <a href="https://www.harleydykstra.com.au" target="_blank">www.harleydykstra.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Video banner to grab attention</li>
									<li>Email Newsletter Design</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Harley Dysktra Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Harley Dysktra Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Harley Dysktra Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Harley Dysktra Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/HarleyDykstra/index.js